/** Стабильная ссылка: пустой список слов поиска сайдбара мессенджера. */
export const MESSENGER_SIDEBAR_SEARCH_HIGHLIGHT_EMPTY: readonly string[] = [];
